import { useEffect, useState } from 'react';
import CustomisedOtpInput from '../../../../components/otpInput/otpInput';
import OtpSkeleton from '../../../../components/otpInput/otpSkeleton';
import BoxInfoOtpInquiry from '../../../../components/otpInput/inquiry/boxInfoOtpInquiry';
import { Box } from '@mui/material';
import CustomisedButton from '../../../../components/button/button';
import { TotalInquiry } from '../../../../services/inquiry.service';
import { useMutation, useQueryClient } from 'react-query';
import { ApiResultModel } from '../../../../models/common.model';
import { TotalInquiryRequest, IInquiryResponse, IInquiryResult } from '../../../../models/inquiry.model';
import { GUARANTOR_MOBILE, GUARANTOR_REQUIRED_OTP, GUARANTOR_RESULT } from '../../../../config/cacheKey';
import { getTokenClaims } from '../../../../services/auth.service';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import { useDispatch, useSelector } from 'react-redux';
import { changeRouteType, getpervInnerState } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { v4 as uuid } from 'uuid';
import { RootState } from '../../../../redux/store';
import { IGetGuarantorsResponse } from '../../../../models/guarantor.model';
import { IInquiry } from '../../inquiryFee/IInquriry';
export default function InquiryOtp({ setInnerState, setStep, referenceKey }: IInquiry) {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState<boolean>(true);
    const queryClient = useQueryClient();
    const [inquiryRequiredOtp, setInquiryRequiredOtp] = useState(queryClient.getQueryData(GUARANTOR_REQUIRED_OTP) as IInquiryResult);
    const dispatch = useDispatch();

    const otpLenght = 5;
    const mobile = getTokenClaims()?.phoneNumber;
    const randomKeyForDispatch = Math.random();
    const { setHeader } = useAppBar();
    const guarantorKey = useSelector(
        (state: RootState) => state.guarantorInfo.guarantorKey
    );
    let mobileNumber: string = "";
    mobileNumber = (queryClient.getQueryData(GUARANTOR_MOBILE)!);

    useEffect(() => {
        setTimeout(() => setLoading(false), 2000);
        const msg = inquiryRequiredOtp?.inquiryType == 1 || inquiryRequiredOtp?.inquiryType == 3 ? 'استعلام چک برگشتی و معوقات بانکی' : inquiryRequiredOtp?.inquiryType == 5 ? 'استعلام رتبه اعتباری بانکی' : 'استعلام'
        setHeader(msg, 'otp');
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `guarantorIntroduce ${randomKeyForDispatch}` }));

    }, []);


    function handleBtnClick(values: string) {
        const request = {} as TotalInquiryRequest;
        request.otp = values;
        request.referenceKey = referenceKey!;
        request.otpInquiryType = inquiryRequiredOtp?.inquiryType;
        request.otpReference = inquiryRequiredOtp?.inquiryOtpReference;
        request.guarantorKey = guarantorKey;
        InquiryValidationOTPMutation(request);
    }
    const { mutateAsync: InquiryValidationOTPMutation, isLoading } = useMutation(TotalInquiry, {
        onSuccess: (data: ApiResultModel<IInquiryResponse>) => {
            if (data.isSuccess) {
                if (data.data) {
                    setError(false);
                    if (data.data.requiredOtpValidation) {
                        setInnerState!('otp');
                        queryClient.setQueryData(GUARANTOR_REQUIRED_OTP, data.data.requiredOtpValidation);
                        setInquiryRequiredOtp(data.data.requiredOtpValidation);
                        setOtp('');
                    }
                    else if (data.data.inquiries.length > 0) {
                        setInnerState!('guarantorInquiryResult')
                        queryClient.setQueryData(GUARANTOR_RESULT, data.data.inquiries);
                    }
                    else {
                        setStep(uuid);
                    }
                }
            } else {
                setOtp('');
                setError(true);
            }
        },
        onError: () => { },
    });
    if (loading) {
        return <OtpSkeleton />;
    }
    const titleBouncedCheque = <span className='secondaryColorLight-600'>
        کد دسترسی برای{' '}
        <span className="secondaryColorLight-600 ">
            استعلام چک برگشتی و معوقات بانکی
        </span>{' '}
        به شماره همراه{' '}
        <span className="yekanBakhFaNum">{mobileNumber ? mobileNumber : mobile}</span> ارسال
        شده است.
    </span>;
    const titleCredit = <span className='secondaryColorLight-600'>
        کد دسترسی برای{' '}
        <span className="secondaryColorLight-600 ">
            استعلام رتبه اعتباری بانکی
        </span>{' '}
        به شماره همراه{' '}
        <span className="yekanBakhFaNum">{mobileNumber ? mobileNumber : mobile}</span> ارسال
        شده است.
    </span>;


    return (
        <div className="container-height-drawer">
            <Box className='content-container'>
                <div className='drawer-content'>
                    <div className='!pb-4 '>
                        <BoxInfoOtpInquiry title={inquiryRequiredOtp?.inquiryType == 1 || inquiryRequiredOtp?.inquiryType == 3 ? titleBouncedCheque : inquiryRequiredOtp?.inquiryType == 5 ? titleCredit : ''} />
                    </div>

                    {error && <div
                        className="text-center primaryErrorColorLight mt-5 "
                        style={{ fontSize: '12.5px' }}
                    >
                        کد وارد شده اشتباه میباشد.
                    </div>}
                    <div className="mt-4">
                        <CustomisedOtpInput
                            resendOtp={() => handleBtnClick(otp)}
                            otp={otp}
                            otpTime={inquiryRequiredOtp?.otpExpirationMilliSecond}
                            setOtp={setOtp}
                            numInputs={otpLenght}
                            error={error}
                        />
                    </div>
                </div>
                <Box className="py-5">
                    <CustomisedButton
                        title="ثبت و ادامه"
                        disable={otp.length < otpLenght || !otp}
                        onClick={() => handleBtnClick(otp)}
                        type="button"
                    />
                </Box>
                {/* <div
                className="text-center primaryColorLight-900 "
                style={{ marginTop: '30px', fontSize: '14px' }}
            >
                کد تایید را دریافت نکرده اید؟
            </div> */}
            </Box>
        </div>
    );
}
